import { getCountry, getLanguage } from '../utils/helpers';
import cloneDeep from 'lodash/cloneDeep';
export async function routeToShopSeUtils(shopeSeHost, productCR, localeCode) {
  var _a;
  const locale = localeCode.toLowerCase();
  const countryCode = getCountry(locale);
  const languageCode = getLanguage(locale);
  const store = `${countryCode}_${languageCode}`;
  const query = `{ 
    products(filter: { sku: { eq: "${productCR}" }}) {
      items {
        canonical_url
      }
    }
  }`;
  const url = `${shopeSeHost}/graphql`;
  const stringifiedQueryParams = new URLSearchParams({
    query
  }).toString();
  try {
    const shopUrl = `${url}?${stringifiedQueryParams}`;
    const response = await fetch(shopUrl, {
      method: "GET",
      headers: { store },
    });
    const { data } = await response.json();
    const items = (_a = data === null || data === void 0 ? void 0 : data.products) === null || _a === void 0 ? void 0 : _a.items;
    if (!(items === null || items === void 0 ? void 0 : items.length)) {
      console.warn('No data found');
      return;
    }
    const { canonical_url: canonicalUrl } = items[0];
    if (!canonicalUrl)
      return;
    return `${shopeSeHost}${locale}/${canonicalUrl}`;
  }
  catch (error) {
    console.error(`[PES] Could not perform graphql call for ${shopeSeHost}`, error);
    return;
  }
}
export const updateBuyOnlineButtonLabel = (ctaArea, btnLabel) => {
  const ctaAreaData = cloneDeep(ctaArea);
  ctaAreaData.buttons.BUY_ONLINE_BUTTON_REGULAR.labels.defaultLabel = btnLabel;
  return ctaAreaData;
};
